import axios from 'axios';

export async function search(name: string): Promise<App.Sms.Data.SmsRecipientData[]> {
  return axios.get(route('api.sms.recipients.index', { name })).then((res) => res.data);
}
